/**
 * Clerk's headless API resolves with a single wrapper error whose own `code` is
 * always `api_response_error`. The reason we act on (for example
 * `form_identifier_not_found`) lives in its nested API errors, so it has to be
 * read from there rather than from `error.code`.
 */
const API_RESPONSE_ERROR = "api_response_error";

const getApiErrorCodes = (error: unknown): string[] => {
  if (!error || typeof error !== "object") {
    return [];
  }

  const { errors } = error as { errors?: unknown };
  if (!Array.isArray(errors)) {
    return [];
  }

  return errors
    .map((entry) =>
      entry && typeof entry === "object"
        ? (entry as { code?: unknown }).code
        : undefined,
    )
    .filter((code): code is string => typeof code === "string");
};

export const hasClerkErrorCode = (error: unknown, code: string) =>
  getApiErrorCodes(error).includes(code);

/**
 * Distinguishes a rejection the API answered with (bad credentials, unknown
 * account) from an infrastructure failure such as a dropped request.
 */
export const isClerkApiResponseError = (error: unknown) =>
  Boolean(
    error &&
      typeof error === "object" &&
      (error as { code?: unknown }).code === API_RESPONSE_ERROR,
  );
